import { Component, DestroyRef, inject, input, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, fromEvent, map, startWith } from 'rxjs';

/**
 * 画面最上部へスクロールするフローティングボタン（複数画面で共通利用）
 * @author CAP
 */
@Component({
  selector: 'app-scroll-to-top-button',
  standalone: true,
  templateUrl: './scroll-to-top-button.component.html',
  styleUrl: './scroll-to-top-button.component.scss',
})
export class ScrollToTopButtonComponent implements OnInit {
  showAfterPx = input(80);
  isVisible = signal(false);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    fromEvent(window, 'scroll', { passive: true })
      .pipe(
        startWith(null),
        map(() => window.scrollY > this.showAfterPx()),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((visible) => this.isVisible.set(visible));
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
